import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default function getList(search, apiFun, type) {
  const store = useStore()
  // 获取列表
  const listData = ref([])
  const listTotal = ref(0)
  const getList = async() => {
    store.dispatch('app/setLoading', true)
    try {
      const searchData = {}
      for (const i in search) {
        if (search[i]) {
          searchData[i] = search[i]
        }
      }
      const res = await apiFun(searchData)
      if (type) {
        if (typeof type === 'object') {
          listData.value = res.data[type.data] ? res.data[type.data] : []
          listTotal.value = res.data[type.total]
        } else {
          listData.value = res.data[type].pages
          listTotal.value = res.data[type].total
        }
      } else {
        listData.value = res.data.pages
        listTotal.value = res.data.total
      }
    } finally {
      store.dispatch('app/setLoading', false)
    }
  }
  onMounted(getList)
  // 搜索
  const searchFun = () => {
    store.dispatch('app/setCurrentPage', 1)
    getList()
  }
  return {
    listData,
    listTotal,
    getList,
    searchFun
  }
}
